import { render } from "./CChangePageTemplate.vue?vue&type=template&id=eda613b8"
import script from "./CChangePageTemplate.vue?vue&type=script&lang=js"
export * from "./CChangePageTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__